// DS: i1.15
import React from 'react';
import IconWrap from '../../IconWrap';
const DreamUpStars = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.02 13.95a2 2 0 0 1 1.26-1.27l1.05-.35-1.05-.35a2 2 0 0 1-1.26-1.26l-.35-1.05-.35 1.05a2 2 0 0 1-1.27 1.26L5 12.33l1.05.35a2 2 0 0 1 1.27 1.27L7.67 15l.35-1.05Zm-4-4a2 2 0 0 1 1.26-1.27l1.05-.35-1.05-.35a2 2 0 0 1-1.26-1.26l-.35-1.05-.35 1.05a2 2 0 0 1-1.27 1.26L1 8.33l1.05.35a2 2 0 0 1 1.27 1.27L3.67 11l.35-1.05Zm6.31.38-.67-2.02a3.11 3.11 0 0 0-1.97-1.97l-2.02-.67 2.02-.68a3.11 3.11 0 0 0 1.97-1.97L10.33 1l.68 2.02A3.11 3.11 0 0 0 12.98 5l2.02.68-2.02.67A3.11 3.11 0 0 0 11 8.31l-.68 2.02Z"
    })));
DreamUpStars.displayName = 'DreamUpStars';
export default DreamUpStars;
